'use strict';

var chunkH6SGADBR_js = require('./chunk-H6SGADBR.js');
var f = require('react');
var h = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var f__default = /*#__PURE__*/_interopDefault(f);
var h__default = /*#__PURE__*/_interopDefault(h);

var p=h__default.default.p`
    font-size: ${({$fontSize:o})=>o};
    font-weight: ${({$fontWeight:o})=>o};
    line-height: ${({$lineHeight:o})=>o};
    color: ${({$color:o})=>o};
    text-decoration: ${({$strikeThrough:o})=>o?"line-through":"none"};
    margin: 0;
    padding: 0;
    `,b=({level:o,children:r,fontWeight:n="regular",color:l="",onClick:g=()=>{},strikeThrough:s=!1})=>{let t=chunkH6SGADBR_js.a(),a=chunkH6SGADBR_js.b();return f__default.default.createElement(p,{$fontSize:t[o].fontSize,$lineHeight:t[o].lineHeight,$fontWeight:a[n],$color:l,onClick:g,$strikeThrough:s},r)};

exports.a = b;
